@if (!item) {
  <div class="empty-state">
    @if (section() === 'groups') {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-contacts-folder.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No group selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewGroup()">
          <app-icon name="sapphire-groups" />
          Create a new group
        </app-button2>
      </app-no-content-stub>
    } @else {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-contacts.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No contact selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewContact()">
          <app-icon name="contacts" />
          Add a new contact
        </app-button2>
      </app-no-content-stub>
    }
  </div>
}

@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.CONTACT) {
      <app-contact-form
        id="contact-form"
        [contact]="asContact(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.GROUP) {
      <app-group-form
        id="group-form"
        [group]="asGroup(item)"
        (close)="handleFormClose($event)"
        />
    }
  }
}
